import React from 'react';
import { Button } from 'reactstrap';
import FileSaver from 'file-saver';
import jsonToCsv from '../../utils/jsonToCsv';
import {getAllOfflineRequests} from '../../services/api/offline-consult'
import moment from 'moment';

export default class DownloadCsv extends React.Component {

    handleClick = () => {
        if(this.props.isCashless){
          this.props.callback().then(response => {
            console.log({response}, '[callback]')
            const jsonArray = response.result
            // remove walletPayload from jsonArray
            const newJsonArray = jsonArray.map(item => {
              item.dob = moment(item.dob).format('DD/MM/YYYY');
              item.appointmentDate = moment(item.appointmentDate).format('DD/MM/YYYY');
              item.requestDate = moment(item.requestDate).format('DD/MM/YYYY');
              item.createdAt = moment(item.createdAt).format('DD/MM/YYYY');
              item.updatedAt = moment(item.updatedAt).format('DD/MM/YYYY');
              item.requestedAppointmentDate = moment(item.requestedAppointmentDate).format('DD/MM/YYYY');
              item.age = moment().diff(moment(item.dob), 'years');
              item.gender = item.gender ? item.gender.charAt(0).toUpperCase() + item.gender.slice(1) : '';
              item.appointmentCompleted = item.appointmentCompleted ? 'Yes' : 'No';
              delete item.walletPayload;
              return item;
            });
            const csv = jsonToCsv(newJsonArray);

            // console.log(csv);
            // Download this csv somehow
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
            FileSaver.saveAs(blob, this.props.fileName || 'cashless_vaccination.csv');
          })
        } else if (this.props.isCashlessDental) {
          this.props.callback().then(response => {
            console.log({response}, '[callback]')
            const jsonArray = response.rows || []
            // itemBreakdown:true rows come back already flattened (no
            // procedureDetails key); non-breakdown rows nest procedures under
            // procedureDetails[]. Normalize both to one row per procedure with
            // explicit defaults, since jsonToCsv derives its header row from
            // just the first array entry.
            const newJsonArray = jsonArray.flatMap(item => {
              const { walletPayload, procedureDetails, ...rest } = item;
              const procedureRows = procedureDetails && procedureDetails.length
                ? procedureDetails
                : [{}];
              return procedureRows.map(procedure => {
                const merged = { ...rest, ...procedure };
                return {
                  ...merged,
                  patientName: merged.patientName || '',
                  patientMobile: merged.patientMobile ?? '',
                  appointmentDate: merged.appointmentDate || '',
                  partnerName: merged.partnerName || '',
                  procedureRequestsId: merged.procedureRequestsId ?? '',
                  procedureId: merged.procedureId ?? '',
                  procedureName: merged.procedureName || '',
                  cost: merged.cost ?? '',
                  walletDeduction: merged.walletDeduction ?? '',
                  success: merged.success ?? '',
                  procedureRefundStatus: merged.procedureRefundStatus ? 'Refunded' : '',
                  mdpProcedureId: merged.mdpProcedureId ?? '',
                  treatmentId: merged.treatmentId ?? '',
                  procedureCompletedAt: merged.procedureCompletedAt ?? '',
                  providerId: merged.providerId ?? '',
                  serviceProvider: merged.serviceProvider || '',
                };
              });
            });
            const csv = jsonToCsv(newJsonArray);

            // console.log(csv);
            // Download this csv somehow
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
            FileSaver.saveAs(blob, this.props.fileName || 'cashless_dental.csv');
          })
        }
       else if(this.props.jsonArray){   
        if(this.props.jsonArray.length === 0){
          return;
        }
          const csv = jsonToCsv(this.props.jsonArray);    
          // console.log(csv);     // Download this csv somehow     
          const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' }); 
          FileSaver.saveAs(blob, this.props.fileName || 'exports.csv');    }    
        else{
          //const { jsonArray, fileName } = this.props;
          return getAllOfflineRequests(this.props.params).then((jsonArray) => {
            console.log(jsonArray, 'json response from backend');
            if (!jsonArray) {
              return;
            }
            const csv = jsonToCsv(jsonArray.result);

            // console.log(csv);
            // Download this csv somehow
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
            FileSaver.saveAs(blob, 'offline request' || 'exports.csv');
          });
        }
    };

    render() {
        return (
            <Button onClick={this.handleClick}>
                {this.props.downloadButtonText || 'CSV'}
            </Button>
        );
    }
}
